export default __webpack_public_path__ + "static/media/photo--sm--misc-24.56fb4ff3.jpg";